import React from 'react';
import {
  Copy,
  Flex,
  Loader,
  Squish,
  Stack,
} from '@grubhubprod/gh-cookbook-react';

export function InsightsDashboardLoader(): JSX.Element {
  return (
    <Squish bg="globals.white" borderRadius="medium" padding="96px 64px">
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
      >
        <Stack y="x-sm">
          <Loader size="md" />
        </Stack>
        <Copy variant="body">Loading...</Copy>
      </Flex>
    </Squish>
  );
}
